var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "pets" },
    [
      _c("form-section", {
        attrs: { sectionTitle: _vm.$t("applications.pets"), wideFirstCol: "" },
        scopedSlots: _vm._u([
          {
            key: "col-1",
            fn: function() {
              return [
                _vm._l(_vm.entitiesData, function(pet) {
                  return _c(
                    "div",
                    { key: pet.id },
                    [
                      _c("control-tool-bar", {
                        attrs: {
                          id: pet.id,
                          title: _vm.$t("applications.pet"),
                          removeable: pet.removeable
                        },
                        on: {
                          remove: function($event) {
                            return _vm.removeEntity(pet.id)
                          }
                        }
                      }),
                      _c("applicant-pet", {
                        attrs: { modelData: pet },
                        on: {
                          update: function($event) {
                            return _vm.update(pet.id, "root", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                }),
                _vm.entitiesData.length < _vm.MAX_PETS
                  ? _c(
                      "v-layout",
                      { staticClass: "mt-1" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mb-2",
                            attrs: { color: "secondary", dark: "" },
                            on: {
                              click: function($event) {
                                return _vm.createEntity("pet")
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v("add_circle")
                            ]),
                            _vm._v(_vm._s(_vm.$t("applications.add-pet")) + " ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }